module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1W30g"))).then(() => parcelRequire('hEqeo'));